import { createFileRoute } from '@tanstack/react-router'
import { ShiftAlertsPage } from '@/features/scheduler/pages/shift-alerts-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/scheduler/alerts'
)({
  component: ShiftAlertsPage,
})
